import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminAuth } from "../lib/adminApi";

const AdminAuthCtx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const token = adminAuth.getToken();
        if (!token) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const me = await adminAuth.me();
            setUser(me);
        } catch (_e) {
            setUser(null);
            adminAuth.clearToken();
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = useCallback(async (username, password) => {
        await adminAuth.login(username, password);
        await refresh();
    }, [refresh]);

    const logout = useCallback(async () => {
        await adminAuth.logout();
        setUser(null);
    }, []);

    return (
        <AdminAuthCtx.Provider value={{ user, loading, login, logout, refresh }}>
            {children}
        </AdminAuthCtx.Provider>
    );
};

export const useAdminAuth = () => {
    const ctx = useContext(AdminAuthCtx);
    if (!ctx) throw new Error("useAdminAuth must be used inside AdminAuthProvider");
    return ctx;
};
